import {
  faEnvelopeOpenText,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import { ContactListItem } from "components/list/ContactListItem";
import { PRONTLIFE_EMAIL, PRONTLIFE_WHATSAPP_NUMBER } from "constants/contacts";
import React from "react";
import { sendAnalyticEventWhatsapp } from "utils/store-link";
import { formatString } from "utils/strings";

export const FooterContactsList = () => {
  return (
    <ul className="menu-list list-unstyled align-self-sm-left">
      <ContactListItem
        icon={faEnvelopeOpenText}
        link={{
          href: `mailto:${PRONTLIFE_EMAIL}`,
          content: `${PRONTLIFE_EMAIL}`,
        }}
      />
           <ContactListItem
        icon={["fab", "whatsapp"]}
        onClick={() => sendAnalyticEventWhatsapp()}
        link={{
          content: `${formatString(
            PRONTLIFE_WHATSAPP_NUMBER,
            "+## (##) #####-####"
          )}`,

          href: `https://api.whatsapp.com/send?phone=+${PRONTLIFE_WHATSAPP_NUMBER}&text=Olá, quero conhecer melhor o ProntLife.`,
        }}
      />
      <ContactListItem
        icon={["fab", "instagram"]}
        link={{
          content: "@prontlife",
          href: "https://www.instagram.com/prontlife/",
        }}
      />
    </ul>
  );
};
